import { inject, Injectable, signal } from '@angular/core';
import { ClientEntity, OrderController, OrderEntity } from '@domain';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OrderCreateService {
    public step = signal(0);
    public description = signal<string>('');
    public client = signal<ClientEntity>(null);
    /** Cadastro de cliente aberto por cima do fluxo, sem sair da criação do serviço. */
    public showCreateClient = signal<boolean>(false);

    // * [Injects]
    private _orderController = inject(OrderController);

    public nextStep(): void {
        if (this.step() >= 1) return;

        this.step.set(this.step() + 1);
    }

    public previousStep(): void {
        if (this.step() <= 0) return;

        this.step.set(this.step() - 1);
    }

    public create(): Observable<{ order: OrderEntity; client: ClientEntity }> {
        return this._orderController.insert(this.client());
    }

    public clear(): void {
        this.step.set(0);
        this.description.set('');
        this.client.set(null);
        this.showCreateClient.set(false);
    }
}
